import React, { useState, forwardRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalenderIc from "../assets/svg/CalenderIc.svg"; // your calendar icon

// Custom button for the datepicker
const CustomDateButton = forwardRef(({ value, onClick, onClear }, ref) => (
  <button
    type="button"
    className="date-range-btn"
    onClick={onClick}
    ref={ref}
    style={{
      padding: "9px 16px",
      //   backgroundColor: "#FFFFFF",
      color: "#4F46E5",
      border: "1px solid #4F46E5",
      display: "flex",
      alignItems: "center",
      borderRadius: "8px",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      position: "relative",
      gap: "6px",
      width: "250px",

      justifyContent: "space-between",
    }}
  >
    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
      <img src={CalenderIc} alt="Calendar" style={{ width: 16, height: 16 }} />
      <span style={{ whiteSpace: "nowrap", color: "#4F46E5" }}>
        {value || "Filter by date range"}
      </span>
    </div>

    {/* Clear (×) icon */}
    {value && (
      <span
        style={{
          marginLeft: "auto",
          color: "#999",
          fontWeight: "bold",
          cursor: "pointer",
          fontSize: "16px",
        }}
        onClick={(e) => {
          e.stopPropagation(); // prevent opening the calendar
          onClear?.(); // call parent handler
        }}
      >
        ×
      </span>
    )}
  </button>
));
export default function DateRangeFilter({ dateRange, setDateRange, onChange }) {
  const [startDate, endDate] = dateRange;

  const handleClear = () => {
    // Clear the local state (actually managed by parent)
    setDateRange([null, null]);

    // Notify parent that the range has been cleared
    onChange?.([null, null]);
  };

  return (
    <DatePicker
      selected={startDate}
      onChange={(update) => {
        setDateRange(update);
        onChange?.(update); // notify parent on every change
      }}
      startDate={startDate}
      endDate={endDate}
      selectsRange
      dateFormat="yyyy-MM-dd"
      customInput={<CustomDateButton onClear={handleClear} />}
    />
  );
}
